import React from "react";
import Slider from "react-slick";

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-right" />
    </button>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-left" />
    </button>
  );
}

const BannerOne = ({ banners }) => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    autoplay: true,
    autoplaySpeed: 3000,
    dotsClass: "slick-dots", // Custom class for styling
  };

  return (
    <div className="banner">
      <div className="pb-20">
        <div className="overflow-hidden arrow-center relative">
          <div className="banner-slider" style={{ position: "relative" }}>
            <Slider {...settings}>
              {banners?.map((banner) => (
                <div className="banner-slider__item" key={banner.id}>
                  <div
                    className="banner-slider__inner flex w-full relative"
                    style={{
                      width: "100%",
                      backgroundImage: `url(${banner.imageLink})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      height: "50vh",
                    }}
                  >
                    <div className="banner-item__content w-1/2 p-8 flex flex-col justify-center z-10">
                      <h1 className="banner-item__title text-4xl font-semibold text-white mb-6">
                        {banner.title}
                      </h1>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerOne;
